/*
 * moleculer
 * Copyright (c) 2018 MoleculerJS (https://github.com/moleculerjs/moleculer)
 * MIT Licensed
 */

"use strict";

const Registry = require("./registry");

module.exports = Registry;

module.exports.Endpoint = require("./endpoint");
